export const productFormValidator = (
    field: string,
    inputValue: string | { id?: string } | File | null | undefined,
    input?: any,
): { [key: string]: string } | null => {
    const validateFields = [
        'name',
        'price',
        'image',
        'grossWeight',
        'length',
        'width',
        'height',
        'fillerType',
        'fabricType',
        'category',
        'quantity',
        'articleNumber',
    ];
    let value = '';
    if (!validateFields.includes(field)) {
        return null;
    }
    if (field === 'fillerType' || field === 'fabricType') {
        const fillerId = String(input?.fillerType?.id || '').trim();
        const fabricId = String(input?.fabricType?.id || '').trim();
        const hasAny = Boolean(fillerId || fabricId);
        if (hasAny) return null;
        const msg = 'Укажите тип ткани или тип наполнителя';
        return { fillerType: msg, fabricType: msg };
    }
    if (typeof inputValue === 'string') {
        value = inputValue.trim();
    }
    if (inputValue !== null && typeof inputValue === 'object' && !(inputValue instanceof File)) {
        if ('id' in inputValue && inputValue.id) {
            value = String(inputValue.id).trim();
        } else {
            value = '';
        }
    }
    if (field === 'image') {
        if (inputValue === null || inputValue === undefined) {
            return { image: 'Главная иллюстрация обязательна' };
        }
        if (inputValue instanceof File) {
            const allowed = ['image/png', 'image/jpeg', 'image/jpg'];
            if (!allowed.includes(inputValue.type)) {
                return { image: 'Загрузите изображение .png, .jpg или .jpeg' };
            }
            return null;
        }
        if (typeof inputValue === 'string') {
            if (!inputValue.trim()) {
                return { image: 'Некорректный идентификатор изображения' };
            }
            return null;
        }
        return { image: 'Неверный формат изображения' };
    }
    if (value.length === 0 && !(inputValue instanceof File)) {
        return { [field]: 'Поле не может быть пустым' };
    }
    return null;
};

export const categoryFormValidator = (field: string, inputValue: string | { [key: string]: string }) => {
    const validateFields = ['name', 'url'];

    if (!validateFields.includes(field) || typeof inputValue === 'object') {
        return null;
    }

    if (inputValue.trim().length === 0) {
        return {
            [field]: 'Поле не может быть пустым',
        };
    }

    if (field === 'url') {
        const regexp = /^[0-9A-Za-z-]+$/;
        const url = regexp.test(inputValue);

        if (url) return null;

        return {
            [field]: 'URL может содержать только цифры, буквы и дефисы',
        };
    }
    return null;
};

export function promoCodeFormValidator(field: string, inputValue: string | { [k: string]: string } | File): { [k: string]: string } | null {
    const errors: { [k: string]: string } = {};
    switch (field) {
        case 'code': {
            const value = String(inputValue || '').trim();
            if (!value) errors.code = 'Ключ обязателен';
            else if (!/^[A-Z0-9-_]+$/.test(value)) errors.code = 'Допустимы A-Z, 0-9, -, _';
            break;
        }
        case 'discountType': {
            if (!inputValue) errors.discountType = 'Укажите тип скидки';
            break;
        }
        case 'discountValue': {
            const num = Number(inputValue);
            if (!num) errors.discountValue = 'Укажите размер';
            else if (num < 1 || num > 10000) errors.discountValue = '1–10000';
            break;
        }
        case 'type': {
            if (!inputValue) errors.type = 'Укажите тип';
            break;
        }
        case 'phone': {
            const value = String(inputValue || '');
            if (value && !/^\+?\d{10,15}$/.test(value)) {
                errors.phone = 'Формат +79991234567';
            }
            break;
        }
        case 'usageLimit': {
            const num = Number(inputValue);
            if (!isNaN(num) && (num < 1 || num > 10000)) {
                errors.usageLimit = '1–10000';
            }
            break;
        }
        default:
            break;
    }

    return Object.keys(errors).length ? errors : null;
}

export const fillerTypeFormValidator = (field: string, inputValue: string | { [key: string]: string }) => {
    const validateFields = ['name', 'url'];
    if (!validateFields.includes(field) || typeof inputValue === 'object') {
        return null;
    }
    if (inputValue.trim().length === 0) {
        return {
            [field]: 'Поле не может быть пустым',
        };
    }
    if (field === 'url') {
        const regexp = /^[0-9A-Za-z-]+$/;
        const url = regexp.test(inputValue);
        if (url) return null;
        return {
            [field]: 'URL может содержать только цифры, буквы и дефисы',
        };
    }
    return null;
};

export const fabricTypeFormValidator = (field: string, inputValue: string | { [key: string]: string }) => {
    const validateFields = ['name', 'url'];
    if (!validateFields.includes(field) || typeof inputValue === 'object') {
        return null;
    }
    if (inputValue.trim().length === 0) {
        return {
            [field]: 'Поле не может быть пустым',
        };
    }
    if (field === 'url') {
        const regexp = /^[0-9A-Za-z-]+$/;
        const url = regexp.test(inputValue);
        if (url) return null;
        return {
            [field]: 'URL может содержать только цифры, буквы и дефисы',
        };
    }
    return null;
};

export const cartFormValidator = (field: string, inputValue: string | { [key: string]: string }) => {
    const validateFields = ['name', 'phone'];
    if (!validateFields.includes(field) || typeof inputValue === 'object') {
        return null;
    }
    if (inputValue.trim().length === 0) {
        return {
            [field]: 'Поле не может быть пустым',
        };
    }
    return null;
};

export const groupFormValidator = (field: string, inputValue: string | { [key: string]: string } | File): { [key: string]: string } | null => {
    const errors: Record<string, string> = {};
    if (field === 'name' && typeof inputValue === 'string' && !inputValue.trim()) {
        errors.name = 'Название обязательно';
    }
    if (field === 'url' && typeof inputValue === 'string' && !inputValue) {
        errors.url = 'Выберите критерий';
    }
    return Object.keys(errors).length ? errors : null;
};
